import { INDUSTRY_GRP_INIT_LOADING, INDUSTRY_GRP_INIT_SUCCESS, INDUSTRY_GRP_INIT_FAIL, OCCUPATION_INIT_LOADING, OCCUPATION_INIT_SUCCESS, OCCUPATION_INIT_FAIL,
  RELATIONSHIP_INIT_LOADING, RELATIONSHIP_INIT_FAIL, RELATIONSHIP_INIT_SUCCESS, TERM_REASON_INIT_LOADING, TERM_REASON_INIT_SUCCESS, TERM_REASON_INIT_FAIL, INJURED_PERSON_TYPE_INIT_LOADING, INJURED_PERSON_TYPE_INIT_SUCCESS, INJURED_PERSON_TYPE_INIT_FAIL } from '@/store/types'
import http from '@/utils/ajax'
import { extractMenu, extractMessages } from '@/utils/extract'
import clone from 'clone'

const initialState = {
  init: 0,
  initErr: [],
  menu: {},
  occupation: {
    init: 0,
    initErr: [],
    menu: {}
  },
  relationship: {
    init: 0,
    initErr: [],
    menu: {}
  },
  termReason: {
    init: 0,
    initErr: [],
    menu: {}
  },
  injuredPersonType: {
    init: 0,
    initErr: [],
    menu: {}
  }
}

const getters = {

}

const mutations = {
  [INDUSTRY_GRP_INIT_LOADING](state) {
    state.init = 0
    state.menu = {}
    state.initErr = []
  },
  [INDUSTRY_GRP_INIT_SUCCESS](state, data) {
    state.init = 1
    state.menu = data ? data.menu : null
    state.initErr = []
  },
  [INDUSTRY_GRP_INIT_FAIL](state, err) {
    state.init = 2
    state.menu = {}
    state.initErr = err
  },
  [OCCUPATION_INIT_LOADING](state) {
    state.occupation.init = 0
    state.occupation.menu = {}
    state.occupation.initErr = []
  },
  [OCCUPATION_INIT_SUCCESS](state, data) {
    state.occupation.init = 1
    state.occupation.menu = data ? data.menu : null
    state.occupation.initErr = []
  },
  [OCCUPATION_INIT_FAIL](state, err) {
    state.occupation.init = 2
    state.occupation.menu = {}
    state.occupation.initErr = err
  },
  [RELATIONSHIP_INIT_LOADING](state) {
    state.relationship.init = 0
    state.relationship.menu = {}
    state.relationship.initErr = []
  },
  [RELATIONSHIP_INIT_SUCCESS](state, data) {
    state.relationship.init = 1
    state.relationship.menu = data ? data.menu : null
    state.relationship.initErr = []
  },
  [RELATIONSHIP_INIT_FAIL](state, err) {
    state.relationship.init = 2
    state.relationship.menu = {}
    state.relationship.initErr = err
  },
  [TERM_REASON_INIT_LOADING](state) {
    state.termReason.init = 0
    state.termReason.menu = {}
    state.termReason.initErr = []
  },
  [TERM_REASON_INIT_SUCCESS](state, data) {
    state.termReason.init = 1
    state.termReason.menu = data ? data.menu : null
    state.termReason.initErr = []
  },
  [TERM_REASON_INIT_FAIL](state, err) {
    state.termReason.init = 2
    state.termReason.menu = {}
    state.termReason.initErr = err
  },
  [INJURED_PERSON_TYPE_INIT_LOADING](state) {
    state.injuredPersonType.init = 0
    state.injuredPersonType.menu = {}
    state.injuredPersonType.initErr = []
  },
  [INJURED_PERSON_TYPE_INIT_SUCCESS](state, data) {
    state.injuredPersonType.init = 1
    state.injuredPersonType.menu = data ? data.menu : null
    state.injuredPersonType.initErr = []
  },
  [INJURED_PERSON_TYPE_INIT_FAIL](state, err) {
    state.injuredPersonType.init = 2
    state.injuredPersonType.menu = {}
    state.injuredPersonType.initErr = err
  }

}

const actions = {
  async industryParamInit({ commit, rootState }) {
    const apiUrl = rootState.app.menu.industryParam
    commit(INDUSTRY_GRP_INIT_LOADING)
    if (apiUrl) {
      try {
        const result = await http.get(apiUrl)
        const menu = extractMenu(result.data._links)
        const commitResult = {
          menu
        }
        commit(INDUSTRY_GRP_INIT_SUCCESS, commitResult)
      } catch (error) {
        commit(INDUSTRY_GRP_INIT_FAIL, extractMessages(error))
      }
    }
  },
  async occupationInit({ commit, rootState }) {
    const apiUrl = rootState.industryParam.menu.initOccupation
    commit(OCCUPATION_INIT_LOADING)
    try {
      const result = await http.get(apiUrl)
      const menu = extractMenu(result.data._links)
      const commitResult = {
        menu: menu
      }
      commit(OCCUPATION_INIT_SUCCESS, commitResult)
    } catch (error) {
      commit(OCCUPATION_INIT_FAIL, extractMessages(error))
    }
  },
  async relationshipInit({ commit, rootState }) {
    const apiUrl = rootState.industryParam.menu.initRelationship
    commit(RELATIONSHIP_INIT_LOADING)
    try {
      const result = await http.get(apiUrl)
      const menu = extractMenu(result.data._links)
      const commitResult = {
        menu: menu
      }
      commit(RELATIONSHIP_INIT_SUCCESS, commitResult)
    } catch (error) {
      commit(RELATIONSHIP_INIT_FAIL, extractMessages(error))
    }
  },
  async termReasonInit({ commit, rootState }) {
    const apiUrl = rootState.industryParam.menu.initTermReason
    commit(TERM_REASON_INIT_LOADING)
    try {
      const result = await http.get(apiUrl)
      const menu = extractMenu(result.data._links)
      const commitResult = {
        menu: menu
      }
      commit(TERM_REASON_INIT_SUCCESS, commitResult)
    } catch (error) {
      commit(TERM_REASON_INIT_FAIL, extractMessages(error))
    }
  },
  async injuredPersonTypeInit({ commit, rootState }) {
    const apiUrl = rootState.industryParam.menu.initInjured
    commit(INJURED_PERSON_TYPE_INIT_LOADING)
    try {
      const result = await http.get(apiUrl)
      const menu = extractMenu(result.data._links)
      const commitResult = {
        menu: menu
      }
      commit(INJURED_PERSON_TYPE_INIT_SUCCESS, commitResult)
    } catch (error) {
      commit(INJURED_PERSON_TYPE_INIT_FAIL, extractMessages(error))
    }
  }
}

export default {
  state: clone(initialState),
  getters,
  mutations,
  actions
}
